<template>
<div id="viewPage">
  <MainPage />
</div>
</template>

<script>
import MainPage from '@/view/MainPage.vue';

export default {
  name: 'ViewPage',
  components: {
    MainPage
  },
}
</script>

<style>
/* body {
    width: 100% !important;
    height: 100%;
 } */
</style>
